import { createContext } from "react";
import type { ZendeskContextType } from "./types";

export const ZendeskContext = createContext<ZendeskContextType>({
  isZendeskLoaded: false,
  unreadMessages: 0,
  openChat: () => {},
  closeChat: () => {},
  isOpen: false,
  hasDigitalLine: false,
  callDigitalLine: () => {},
  setConversationalFields: () => {},
  setConversationalTags: () => {},
  logout: () => {},
});
